import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import { LangContext } from "../LangContext.jsx";
import FrequencyCreator from './FrequencyCreator';
import DocumentFieldsCFDIEgreso from './DocumentFieldsCFDIEgreso';
import DocumentFieldsCFDIIngreso from './DocumentFieldsCFDIIngreso';
import DocumentFieldsCFDINomina from './DocumentFieldsCFDINomina';
import DocumentFieldsCFDIPagos from './DocumentFieldsCFDIPagos';
import DocumentFieldsCFDIRetenciones from './DocumentFieldsCFDIRetenciones';
import DocumentFieldsCFDITraslado from './DocumentFieldsCFDITraslado';
import CfdiDocumentTemplate from './CfdiDocumentTemplate';
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { GENERAL_DOCUMENT_TYPE, DOC2SIGN_DOCUMENT_TYPE, CFDI_MASIVO , CFDI, CEDULA_FISCAL , SUA, PERSONA_MORAL , PERSONA_FISICA, SIMPLIFICADO_DE_CONFIANZA, REGION_FRONTERIZA, ISR, SAT, REPSE, IMSS , INFONAVIT } from '../constants';

class MassiveCfdiForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = { 
                frequencyType:'once', 
                instructions:'',
                selectedFields: [],
                fv:'',
                is_automatic:1,
                active:true, 
                type_id:CFDI,
                cfdi:'',
                cfdis: [],
                selectedMimes:[5],
                cfdiType: 'CFDI', 
                title: '',
                templateTitleExists: false,
                templateTitleMessage: '',
                checkingTemplateTitle: false,
        };
        this.documentFields = React.createRef();
        this.templateTitleTimer = null;
    }  

    updateParentState = (updatedState) => {
        this.setState(updatedState);
    }
 
    async componentDidMount() {
        const { lang } = this.context; 
        await this.getMimes() 
        await this.getCfdis()
        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                cfdi_id:{
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.nombre_requerido')
                        },
                    }
                }, 
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });
        this.setState({fv: fv});
        const btnPublish = document.getElementById('btnPublish');
        btnPublish.addEventListener('click', () => {
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    this.save();
                }
            })
            let fields = [];
            fields = this.documentFields.current.state.fields 
        })
    }

    save() {
        window.blockUI();

        if (this.state.templateTitleExists) {
            swal.fire({
                text: this.state.templateTitleMessage || 'Ya existe una plantilla con este nombre.',
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
            })
            window.unblockUI();
            return;
        }

        let fields = [];
        let all_fields = [];  
        fields = this.documentFields.current.state.fields 
        all_fields = this.documentFields.current.state.all_fields 
        fields.forEach((el) => { el.required = false; }); 
        
        const emptyTitleFields = fields.filter((el) => el.title.trim() === ''); 
        const fieldsWithValidation = fields.filter((el) => el.hasValidation == true);
        let emptyFields = false; 
        const fieldsWithEmptyConditions = fieldsWithValidation.filter((el) => {
            if (el.conditions) {
                el.conditions.map(con =>{
                    if(con.param1 != 6 && con.param1 != 7 && con.param1 != 8){
                        if(con.param2 === '' || con.param2 === null || con.param2 === undefined ){
                            emptyFields = true
                        }
                    } 
                })
            }
            return el.conditions === undefined || el.conditions.length === 0;
        });  
        if(emptyFields == true){
            swal.fire({
                text: `Contienes condiciones sin valores, favor de revisar`,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }, 
            })
            window.unblockUI();
            return;
        }
        if(fieldsWithEmptyConditions.length > 0){
            swal.fire({
                text: `Todas las validaciones automaticas deben contener al menos una condición`,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }, 
            })
            window.unblockUI();
            return;
        }
        if (emptyTitleFields.length > 0) {
            const emptyFieldIds = emptyTitleFields.map((el) => el.type);
            swal.fire({
                text: `Por favor, completa los títulos de los campos adicionales de tipo: ${emptyFieldIds.join(', ')}`,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }, 
            })
            window.unblockUI();
            return;
        }  
        if (this.state.active) {
            KTUtil.btnWait(KTUtil.getById('btnPublish'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        } else {
            KTUtil.btnWait(KTUtil.getById('btnSave'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        } 
        const params = JSON.stringify({
            every: this.state.every,
            repeat_on: this.state.repeatOn,
            ends: this.state.ends,
            cicles: this.state.cicles,
            day_of_week: this.state.dayOfWeek,
            month_frequency_type: this.state.monthFrequencyType,
            refer_day: this.state.ReferDay,
            day: this.state.day,
            day_of_month: this.state.dayOfMonth,
            month_of_year: this.state.monthOfYear,
            instructions:this.state.instructions,
            title: this.state.title,
            frequency: this.state.frequencyType,
            size: parseInt(this.props.max_upload_size || 10, 10),
            mimes: this.state.selectedMimes,
            is_automatic: 0,
            cfdi_id: this.state.cfdi,
            api_method: this.state.api_method, 
            required: true,
            active: this.state.active,
            fields: fields,
            all_fields: all_fields,
            period: this.state.period,
            type_id:  this.state.type_id,
            displayCfdiInput:this.state.displayCfdiInput,
            template:this.state.template,
            deleteTemplate: this.state.deleteTemplate,
            dateValidationComponentId:this.state.dateValidationComponentId, 
        })   
        this.create(params) 
    } 

    async create(params) {   
 
        const { lang } = this.context; 
        var form = document.getElementById("frm");
        var formData = new FormData(form);
        await axios.post(
            '/api/documents', params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            if($('#template').val() != ''){
                let documentId = response.data.id;
                axios.post('/api/documents/template/'+documentId,formData).then(res=>{
                })
            }
            window.unblockUI();
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: lang.get('messages.guardado'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                  window.location.href = '/documents';
            });
        }).catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    async getMimes() {
        const res = await axios.get('/api/mimes')
        const filteredMimes = res.data.filter(mime => mime.id !== 5); 
        this.setState({ mimes: filteredMimes }); 
    }

 

    handleInstructionsChange = (e) =>{
        this.setState({
            instructions: e.target.value
        });
    }

    async getCfdis() {
        const res = await axios.get('/api/cfdis')
        this.setState({cfdis: res.data})
    }

    handleCfdiChange = (e) => {
        const index = parseInt(e.target.value);
        if(index == 0){
            this.setState({ cfdi: '' })
        }else{
            this.setState({ cfdi: index })
            let title = this.state.cfdis.filter((cfdi)=>{
                return cfdi.id == index
            })
            this.setState({ title: title[0].name }, () => this.scheduleTemplateTitleCheck())
        }
    }

    handleTemplateTitleChange = (e) => {
        const value = e.target.value;
        this.setState({ title: value }, () => this.scheduleTemplateTitleCheck());
    }

    scheduleTemplateTitleCheck = () => {
        const title = (this.state.title || '').trim();

        if (this.templateTitleTimer) {
            clearTimeout(this.templateTitleTimer);
        }

        if (title.length < 3) {
            this.setState({ templateTitleExists: false, templateTitleMessage: '', checkingTemplateTitle: false });
            return;
        }

        this.setState({ checkingTemplateTitle: true });
        this.templateTitleTimer = setTimeout(() => {
            this.checkTemplateTitleAvailability(title);
        }, 450);
    }

    checkTemplateTitleAvailability = async (title) => {
        try {
            const res = await axios.post('/api/documents/check-title', { title });
            const exists = Boolean(res?.data?.exists);
            const message = res?.data?.message || '';
            this.setState({
                templateTitleExists: exists,
                templateTitleMessage: message,
                checkingTemplateTitle: false,
            });
        } catch (e) {
            this.setState({ checkingTemplateTitle: false });
        }
    }

    handleCfdiTypeChange = (e) => {
        if(e.target.value == 'CFDI'){
            this.setState({ type_id: CFDI, selectedMimes: [5] });
        }
        if(e.target.value == 'CFDI_MASIVO'){ 
            this.setState({ type_id: CFDI_MASIVO, selectedMimes: [10], title:'Nómina Masivo'}); 
        }
        this.setState({ cfdiType: e.target.value });
    }

    render() {
        const { lang } = this.context; 
        return (
            <form id="frm" encType="multipart/form-data">
                <div className="card card-custom gutter-b">
                    <div className="card-body"> 
                        <label className="text-left">¿Qué tipo de carga necesitas?</label>
                            <div className="d-flex ">
                                <div className=" d-flex">
                                    <div className="col-md-6 font-size-h5 text-dark">
                                    <input class="mr-2" type="radio" id="cfdi" name="cfdiType" value="CFDI" 
                                                    checked={this.state.cfdiType === 'CFDI'} 
                                                    onChange={this.handleCfdiTypeChange} 
                                                />
                                                CFDI 
                                    </div>
                                    <div className="col-md-12 font-size-h5 text-dark ">
                                    <input class="mr-2" type="radio" id="cfdiMasivo" name="cfdiType" value="CFDI_MASIVO" 
                                                    checked={this.state.cfdiType === 'CFDI_MASIVO'} 
                                                    onChange={this.handleCfdiTypeChange} 
                                                />
                                                <label htmlFor="cfdiMasivo">CFDI Masivo</label>
                                    </div>
                                </div>
                            </div> 
                         
                    {this.state.cfdiType === 'CFDI' && (
                        <> 
                            <div className="row mt-6"> 
                                <div className="col-sm-4 form-group">
                                    <p className="font-weight-bold">{lang.get('messages.selecciona_el_tipo_de_cfdi')}</p>
                                    <select value={this.state.cfdi} className="form-control" id="cfdi_id" name="cfdi_id" onChange={this.handleCfdiChange }>
                                        <option value="">--Seleccionar--</option>
                                        {this.state.cfdis.map((d, i) => {
                                            return <option key={d.id} value={d.id}>{d.name}</option>;
                                        })}
                                    </select>

                                    <div className="mt-4">
                                        <label className="font-weight-bold">Nombre de plantilla</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={this.state.title || ''}
                                            onChange={this.handleTemplateTitleChange}
                                        />
                                        {this.state.templateTitleExists && (
                                            <div className="text-danger font-weight-bold mt-2">
                                                {this.state.templateTitleMessage || 'Ya existe una plantilla con este nombre.'}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-sm-4 form-group">
                                            <FrequencyCreator updateParentState={this.updateParentState} category={this.props.category} documentType={4}/> 
                                        </div>
                                        <div className="col-sm-4"> 
                                        <label className="text-left">{lang.get('messages.'+this.props.upload_document_template)}</label>
                                        <input id="template" className="form-control "  type="file" name="template"/>
                                    </div>
                            </div>
                            <div className="d-flex">
                                <div className="flex-grow-1">
                                    <div className="row justify-content-center text-left"> 
                                        
                                    </div>
                                    <div className="text-left mt-6"> 
                                        <strong className="mt-6 d-block">{lang.get('messages.maximo_10_mb_por_archivo')}</strong>
                                        <div className="form-group mt-8">
                                            <label className="text-left">{lang.get('messages.instrucciones_de_llenado_de_plantilla')}</label>
                                            <textarea className="form-control" value={this.state.instructions} name="instructions" onChange={this.handleInstructionsChange }></textarea>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>  
                            {this.state.cfdi == 1 && <DocumentFieldsCFDIIngreso ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/>}
                    {this.state.cfdi == 2 && <DocumentFieldsCFDIEgreso ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/>}
                    {this.state.cfdi == 3 && <DocumentFieldsCFDIPagos ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/>}
                    {this.state.cfdi == 4 && <DocumentFieldsCFDINomina ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/>}
                    {this.state.cfdi == 5 && <DocumentFieldsCFDIRetenciones ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/>}
                    {this.state.cfdi == 6 && <DocumentFieldsCFDITraslado ref={this.documentFields} selected_fields={this.state.selectedFields.length > 0 ? this.state.selectedFields : undefined}/>}
 
                    <div className="text-right gap-1 mr-10 mb-10">
                        <a href="/documents" className="btn btn-lg btn-secondary">
                            {lang.get('messages.cancelar')}
                        </a>
                        <button id="btnPublish" type="button" className="btn btn-lg btn-primary ml-4">
                            {lang.get('messages.guardar')}
                        </button>
                    </div> 
                        </>
                        )}
                    </div>  
                    {this.state.cfdiType === 'CFDI_MASIVO' && (
                        <>
                        <CfdiDocumentTemplate max_upload_size={this.props.max_upload_size} />
                        </>
                    )}
                 
                </div>
            </form>
        )
    }
}

export default MassiveCfdiForm;

if (document.getElementById('MassiveCfdiForm')) {
    ReactDOM.render(<MassiveCfdiForm />, document.getElementById('MassiveCfdiForm'));
}
